function initVariantSwitcher() {
  // Construiește un map de rate: variantId -> pret afisat initial
  var priceRates = {};
  
  document.querySelectorAll('.grid-view-item').forEach(function(card) {
    var select = card.querySelector('select[id*="var-"]');
    var priceDiv = card.querySelector('.product-card__price');
    if (!select || !priceDiv) return;
    
    var currentVariantId = select.value;
    var displayedText = priceDiv.textContent.trim();
    var displayedAmount = parseFloat(displayedText.replace(/[^0-9,.]/g, '').replace(',', '.'));
    
    priceRates[card] = {
      displayedAmount: displayedAmount,
      variantId: currentVariantId
    };
  });

  document.querySelectorAll('select[id*="var-"]').forEach(function(select) {
    select.addEventListener('change', function(e) {
      var card = e.target.closest('.grid-view-item');
      if (!card) return;
      
      fetch('/variants/' + e.target.value + '.js')
        .then(function(r) { return r.json(); })
        .then(function(variant) {

          // Imagine
          if (variant.featured_image && variant.featured_image.src) {
            var img = card.querySelector('img');
            if (img) {
              img.src = variant.featured_image.src;
              img.removeAttribute('srcset');
            }
          }

          // Pret
          var priceDiv = card.querySelector('.product-card__price');
          if (priceDiv) {
            var currency = theme.activeCurrency || 'RON';
            var currencySymbols = {
              'RON': 'lei',
              'EUR': '€',
              'GBP': '£',
              'CHF': 'CHF',
              'NOK': 'kr'
            };
            var symbol = currencySymbols[currency] || currency;
            var isPrefix = ['EUR', 'GBP'].indexOf(currency) !== -1;

            // Calculează rata din prețurile fixe setate în catalog
            // /variants/ID.js returnează prețul în moneda pieței active, nu RON!
            var p = variant.price / 100;
            var cp = variant.compare_at_price ? variant.compare_at_price / 100 : null;

            var formatAmt = function(amt) {
              var str = amt.toFixed(2).replace('.', ',');
              return isPrefix ? symbol + str : str + ' ' + symbol;
            };

            if (cp && cp > p) {
              priceDiv.innerHTML =
                '<span style="text-decoration:line-through;color:#999;margin-right:6px;">' + formatAmt(cp) + '</span>' +
                '<span style="color:#e00;">' + formatAmt(p) + '</span>';
            } else {
              priceDiv.innerHTML = formatAmt(p);
            }
          }

          // Buton
          var btn = card.querySelector('button');
          if (!btn) return;
          if (!variant.available) {
            btn.disabled = true;
            btn.textContent = 'Stoc epuizat';
            btn.style.opacity = '0.5';
            btn.style.cursor = 'not-allowed';
          } else {
            btn.disabled = false;
            btn.textContent = 'Adaugă în coș';
            btn.style.opacity = '1';
            btn.style.cursor = 'pointer';
          }
        });
    });
  });

  document.querySelectorAll('.grid-view-item--sold-out').forEach(function(card) {
    var btn = card.querySelector('button');
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = 'Stoc epuizat';
    btn.style.opacity = '0.5';
    btn.style.cursor = 'not-allowed';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantSwitcher);
} else {
  initVariantSwitcher();
}
